import React from 'react';
import { Row, Col, Form, Alert } from 'react-bootstrap';
import { DetailedProduct } from '../../../../api/shop/types/productTypes';
import DetailView from '../../../../Common/DetailView';

interface DetailViewField {
  label: string;
  value: string | number | React.ReactNode;
  isBadge?: boolean;
  span?: number;
}

interface ProductVisibilityProps {
  data: Partial<DetailedProduct>;
  onChange: (updates: Partial<DetailedProduct>) => void;
  isReadOnly?: boolean;
}

const ProductVisibility: React.FC<ProductVisibilityProps> = ({ 
  data, 
  onChange, 
  isReadOnly = false 
}) => {

  // If in read-only mode, show DetailView layout
  if (isReadOnly) {
    const detailFields: DetailViewField[] = [
      { 
        label: 'Featured Product', 
        value: data.visibility?.isFeatured ? 'Yes' : 'No'
      },
    ];

    // Add Featured Rank if the product is featured
    if (data.visibility?.isFeatured) {
      detailFields.push({
        label: 'Featured Rank',
        value: data.visibility?.featuredRank || 1
      });
    }

    return (
      <DetailView
        title="Product Visibility"
        fields={detailFields}
        layout="grid"
        columns={3}
        noWrapper={true}
      />
    );
  }

  return (
    <div>
      <h4 className="product-detail-section-title mb-4">Product Visibility</h4>
      
      <div className="product-detail-visibility-section">
        <Row>
          <Col md={6}>
            <div className="d-flex align-items-center mb-3">
              <Form.Check 
                  type="checkbox"
                  id="isFeatured"
                  checked={data.visibility?.isFeatured || false}
                  onChange={(e) => {
                    onChange({
                      visibility: {
                        ...data.visibility,
                        isFeatured: e.target.checked,
                      }
                    });
                  }}
                className="me-3"
                />
              <div>
                <Form.Label htmlFor="isFeatured" className="product-detail-form-label mb-0 fw-semibold">
                  Featured Product
                </Form.Label>
                  <div className="small text-muted">Show this product as featured across the platform</div>
              </div>
            </div>
          </Col>
          
          {data.visibility?.isFeatured && (
            <Col md={6}>
              <Form.Group>
                <Form.Label className="product-detail-form-label">Featured Rank</Form.Label>
                <Form.Control
                  type="number"
                  value={data.visibility?.featuredRank || 1}
                  onChange={(e) => {
                    onChange({
                      visibility: {
                        isFeatured: data.visibility?.isFeatured || false,
                        ...data.visibility,
                        featuredRank: parseInt(e.target.value) || 1,
                      }
                    });
                  }}
                  className="product-detail-form-control"
                  min="1"
                  max="999"
                  placeholder="Enter rank (1 = highest priority)"
                  style={{ 
                    minHeight: '44px',
                    textAlign: 'center'
                  }}
                />
              </Form.Group>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default ProductVisibility;